import {CircularProgress, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {
    Button,
    DateInput,
    FormWithRedirect,
    Identifier,
    required,
    SelectInput,
    TextInput,
    useListContext,
    useNotify,
    useRefresh,
} from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import {useState} from "react";
import EuroSymbolIcon from '@material-ui/icons/EuroSymbol';
import {useToggler} from "../../../shared/hooks/useToggler";
import {client} from "../../../dataProvider";
import {dateFormatter, generateError, initInput} from "../../../shared/utils";
import {useOptions} from "../../../shared/hooks/useOptions";
import {FormSaveButton} from "../../../components/FormSaveButton";
import {ReferenceInputBank} from "../../../components/reference-inputs/ReferenceInputBank";

export const AddPaymentStatusPayedBulkButton = ({ ids }: { ids?: Identifier[] }) => {
  const { selectedIds, refetch, data, onSelect } = useListContext();


  const [loading, setLoading] = useState(false);
  const dataArray = Object.values(data);

  const { value, setFalse, setTrue } = useToggler();
  const refresh = useRefresh();
  const notify = useNotify();
  const handleSubmit = (values: any) => {
    setLoading(true);

    client(`payment_schedule_status/multiple_collection`, {
      method: "POST",
      data: {
        ids: selectedIds,
        ...values
      }
    }).then((response) => {
      notify("Fatture incassate", "success");
        refresh();
        setFalse()
        onSelect([])
    })
      .catch((error) => {
        generateError(error, notify);
      })
      .finally(() => {
        setLoading(false);
      });


    refetch();
  };
  const { data: options } = useOptions("payment_schedule_status", "POST");
  return options && selectedIds ? (
    <>
      <Button
        size="small"
        color="primary"
        label="Incasso multiplo"
        onClick={() => setTrue()}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <><EuroSymbolIcon /></>}
      </Button>
      <Dialog open={value} maxWidth="sm" fullWidth>
        <FormWithRedirect
          resource="payment_schedule_status"
          save={handleSubmit}
          initialValues={{ ids: selectedIds }}
          render={({ handleSubmitWithRedirect, pristine, saving }) => (
            <>
              <DialogContent>
                <DateInput
                  initialValue={dateFormatter(new Date())}
                  {...initInput("date", options, true)}
                />
                <SelectInput
                  {...initInput("status", options, true, "array")}
                  choices={[
                    { value: "I", display_name: "Fattura incassata/pagata" },
                  ]}
                  defaultValue={"I"}
                />
                  <ReferenceInputBank {...initInput("bank_id", options, true)} label="Banca" defaultValue={1} />
                <SelectInput
                  {...initInput(
                    "collection_type",
                    options,
                    true,
                    "array"
                  )}
                  choices={options.collection_type.choices}
                  validate={[required()]}
                  defaultValue={"MP05"}
                />
                <TextInput {...initInput("notes", options, true)} />
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={setFalse}>
                  <IconCancel />
                </Button>
                <FormSaveButton
                  handleSubmit={() => handleSubmitWithRedirect!()}
                  submitting={loading}
                  pristine={false}
                  label="Crea"
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  ) : null;
};
